import { FormControl, FormGroup } from '@angular/forms';

export class FormGroupUtils {


    public static updateFormGroupEnabled(enable: boolean, form: FormGroup) {
        if (!form || !form.controls) {
          return;
        }
        const formControlsNames: string[] = Object.keys(form.controls);

        for (const formControlName of formControlsNames) {
          const formControl: FormControl = form.controls[formControlName] as FormControl;
          if (enable) {
              formControl.enable({ emitEvent: false });
              formControl.updateValueAndValidity({ emitEvent: false });
          } else {
            formControl.setErrors(null);
            formControl.disable({ emitEvent: false });
          }
        }

        if (!enable) {
            form.clearValidators();
            form.updateValueAndValidity({ onlySelf: false });
        }
      }



}
